@if(!authenticated()) {
  <ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <app-profile-anonymous (loginEvent)="login()" />
  </ion-content>
} @else {
  <ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <app-profile-auth [user]="user()!" />
  </ion-content>
}